<div (popClickOutside)="closeUserCard()">
  <button #userCardButton
          class="user-card-button"
          (click)="toggleUserCard()"
          [class.user-card-btn-active]="showUserCard">
    <i class="fal fa-user-circle"></i>
  </button>

  <div class="user-card"
       #userCard
       [@inOutAnimation]
       *ngIf="showUserCard">
    <div class="user-card-menu">
      <div class="user">
        <i class="fal fa-user-circle"></i>
        <div class="user-data">
          <span class="name">{{ name }}</span>
          <span>{{ company }}</span>
        </div>
      </div>
      <div class="user-card-option">

        <button class="lang-btn fr"
                [class.bold]="languageCode === 'fr'"
                (click)="changeLanguage('fr')">FR</button>

        <button class="lang-btn en"
                [class.bold]="languageCode !== 'fr'"
                (click)="changeLanguage('en')">EN</button>
      </div>
      <div class="user-card-option"
           (click)="goToLogout()">

        <i class="far fa-sign-out-alt"></i>
        <span translate="BUTTON.LOGOUT"></span>
      </div>
    </div>
  </div>
</div>
